// @flow
import React, { useCallback } from "react";
import { connect } from "react-redux";
import cx from "classnames";
import { createStructuredSelector } from "reselect";
import consts from "../../data/consts";
import bindActions, { types as ats } from "../../actions";
import {
	selectPurchaseDetails,
	selectMediaType,
	selectPurchaseAssets,
	selectSubscriptionsByMediaType,
	selectSizeParams,
	selectFormat,
	selectCurrentSubscription,
	selectMetadataSchema,
	selectSelectedItems,
} from "../../selectors";
import PurchasePreview from "../PurchasePreview";
import PurchaseSidePanel from "../PurchaseSidePanel";
import type {
	Subscription, PurchaseDetails, MEDIA_TYPE, FORMATS,
} from "../../data/types";

import "./PurchasePage.scss";

type Props = {|
    mediaType: MEDIA_TYPE,
    assets: Object[],
    subscriptions: Subscription[],
    purchaseDetails: PurchaseDetails,
    sizeParams: Object,
    format: FORMATS,
    currentSubscription: Subscription,
    metadataSchema: Object[],
    selectedItem: Object[],
    actions: { [string]: Function },
|};

export const PurchasePage = (props: Props) => {
	const setPurchaseDetails = props.actions[ats.SET_PURCHASE_DETAILS];

	const changePurchaseDetails = useCallback((data) => {
		setPurchaseDetails(data);
	}, [setPurchaseDetails]);

	const asset = props.assets[0] || props.selectedItem[0];
	const isVideo = props.mediaType === consts.MEDIA_TYPES.VIDEOS;

	return (<div className={cx("purchase-page flex flex-wrap h-100 relative min-h-0 overflow-y-auto")}>
		<PurchasePreview isVideo={isVideo} asset={asset} />

		<PurchaseSidePanel purchaseDetails={props.purchaseDetails}
			currentSubscription={props.currentSubscription}
			metadataSchema={props.metadataSchema}
			asset={asset}
			subscriptions={props.subscriptions}
			sizeParams={props.sizeParams}
			format={props.format}
			mediaType={props.mediaType}
			changePurchaseDetails={changePurchaseDetails}/>
	</div>);
};

export default connect<Props, *, _, _, _, _>(
	createStructuredSelector({
		mediaType: selectMediaType,
		assets: selectPurchaseAssets,
		purchaseDetails: selectPurchaseDetails,
		subscriptions: selectSubscriptionsByMediaType,
		sizeParams: selectSizeParams,
		format: selectFormat,
		currentSubscription: selectCurrentSubscription,
		metadataSchema: selectMetadataSchema,
		selectedItem: selectSelectedItems,
	}),
	(dispatch: Function) => ({
		actions: bindActions(dispatch),
	}),
)(PurchasePage);
